import {SHOULD_COOKIE_BANNER} from "../../utils/constants";
import {isLocalStorageAvailable} from "../isLocalStorageAvailable";

export const setShouldShowCookieBanner = (bool) => {
  if (!isLocalStorageAvailable()) {
    return false;
  }
  localStorage.setItem(SHOULD_COOKIE_BANNER, bool)
};